import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChargingStation } from 'src/app/models/charging-station';
import { AccountService } from 'src/app/services/account/account.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { MapService, ShowOnMapEnum } from 'src/app/services/map/map.service';
import { MapChargingStationDrawerService } from 'src/app/services/map/map-charging-station-drawer.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { MapElementType } from 'src/app/models/map-element-type';
import { ConfirmationDialogComponent } from '../../modals/confirmation-dialog/confirmation-dialog.component';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';

@Component({
  standalone: true,
  selector: 'app-charger-panel',
  templateUrl: './charger-panel.component.html',
  styleUrls: ['./charger-panel.component.scss']
})
export class ChargerPanelComponent implements OnInit, OnDestroy {

  @Input() charger;
  @Input() chargerType: MapElementType | null = null;
  constructor(private readonly consoleLoggerService: ConsoleLoggerService, private readonly mapService: MapService,
    private readonly matDialog: MatDialog,
    private readonly stackedModalsService: StackedModalsService,
    private readonly chargingStationDrawerService: MapChargingStationDrawerService,
    public settingsService: SettingsService,
    public accountService: AccountService,
    public languageService: LanguageService) { }

  ngOnInit(): void {
    if (this.chargerType !== null) {
      this.mapService.setSearchedMapElement(this.chargerType, this.charger);
    }
  }

  ngOnDestroy(): void {
    // Runs when the panel closes via Back (or after unmark) — the *ngIf host
    // removes it, so the locked-open station popup is torn down with the panel.
    this.chargingStationDrawerService.clearShownChargingStation();
  }

  public unmark(): void {
    if (this.chargerType == MapElementType.DisabledChargingStation) {
      this.removeDisabledCharger(this.charger);
    }
    if (this.chargerType == MapElementType.FavoriteChargingStation) {
      this.removeFavoriteCharger(this.charger);
    }
  }

  public removeDisabledCharger(charger: ChargingStation): void {
    const confirmationDialog = this.stackedModalsService.openModal(ConfirmationDialogComponent,
      { data: { title: this.languageService.languageJSON.SettingsDialog_ChargingStation_ReEnable_Title,
        message: this.languageService.languageJSON.SettingsDialog_ChargingStation_Unmark_Desc,
        buttons: [this.languageService.languageJSON.Global_Normal,
          this.languageService.languageJSON.Global_Cancel] }, autoFocus: false });

    confirmationDialog.afterClosed().subscribe((resp) => {
      if (resp) {
        this.settingsService.setToNormalChargingStation(charger.id);
        if (this.accountService.getIsAuthorized()) {
          this.accountService.setDisabledChargingStations().subscribe();
        }
        this.mapService.setChargingStationRecalc();
        this.mapService.ObservableShowOnMap.next({ type: ShowOnMapEnum.BackVehicleOptions, data: this.chargerType });
      }
    });
  }

  public removeFavoriteCharger(charger: ChargingStation): void {
    const confirmationDialog = this.stackedModalsService.openModal(ConfirmationDialogComponent,
      { data: { title: this.languageService.languageJSON.SettingsDialog_ChargingStation_Unmark_Title,
        message: this.languageService.languageJSON.SettingsDialog_ChargingStation_Unmark_Desc,
        buttons: [this.languageService.languageJSON.Global_Normal,
          this.languageService.languageJSON.Global_Cancel] }, autoFocus: false });

    confirmationDialog.afterClosed().subscribe((resp) => {
      if (resp) {
        this.settingsService.setToNormalChargingStation(charger.id);
        if (this.accountService.getIsAuthorized()) {
          this.accountService.setFavoriteChargingStations().subscribe();
        }
        this.mapService.setChargingStationRecalc();
        this.mapService.ObservableShowOnMap.next({ type: ShowOnMapEnum.BackVehicleOptions, data: this.chargerType });
      }
    });
  }

  public goBack(): void {
    this.mapService.ObservableShowOnMap.next({ type: ShowOnMapEnum.BackVehicleOptions, data: this.chargerType });
  }
}
